export const halfOfInteger = 0.5
export const decimalOfInteger = 0.25

export const roundUpWholeInteger = (num: number): number => Math.ceil(num)
export const isWholeInteger = (num: number): boolean => num % 1 === 0

export const roundHalfInteger = (num: number): number => Math.round(num * 2) / 2
export const isHalfInteger = (num: number): boolean => num % halfOfInteger === 0

export const roundDecimalInteger = (num: number): number => Math.round(num * 4) / 4
export const roundUpDecimalInteger = (num: number): number => Math.ceil(num * 4) / 4

export const isDecimalInteger = (num: number): boolean => num % decimalOfInteger === 0

export const roundToPrecision = (val: number, precision: number = 0): number => {
  const factor = 10 ** precision
  return Math.round(val * factor) / factor
}

export const roundDecimal = (num: number): number => roundToPrecision(num, 2)
export const roundHundred = (num: number): number => roundToPrecision(num, 3)
